module.exports = __webpack_public_path__ + "img/collect.b39d7420.svg";